import { useState, useEffect, useMemo } from 'react'
import { X, Plus } from 'lucide-react'

// Multi-select tag picker: chosen tags as removable chips, a dropdown of the
// catalog's existing tags to add from, and a text box for a brand-new tag.
// value / onChange are arrays of lowercase tag names.
export default function TagPicker({ value, onChange, api, id = 'ts-tags' }) {
  const [all, setAll] = useState([])
  const [pick, setPick] = useState('')
  const [draft, setDraft] = useState('')

  useEffect(() => { api.listTags().then(d => setAll(d.tags || [])).catch(() => setAll([])) }, [api])

  const chosen = useMemo(() => new Set(value), [value])
  const available = useMemo(() => all.filter(t => !chosen.has(t)), [all, chosen])
  const norm = (s) => String(s || '').trim().toLowerCase()

  const add = (t) => { const n = norm(t); if (n && !chosen.has(n)) onChange([...value, n]) }
  const remove = (t) => onChange(value.filter(x => x !== t))

  return (
    <div className="ts-tags">
      <div className="ts-tags-chips" aria-live="polite">
        {value.length === 0 && <span className="muted">No tags</span>}
        {value.map(t => (
          <span key={t} className="ts-tag-chip">
            {t}
            <button type="button" onClick={() => remove(t)} aria-label={`Remove tag ${t}`}><X size={11} /></button>
          </span>
        ))}
      </div>
      <div className="ts-tags-add">
        <select id={id} value={pick} onChange={e => { add(e.target.value); setPick('') }} aria-label="Add an existing tag">
          <option value="">{available.length ? `Add existing tag… (${available.length})` : 'No more existing tags'}</option>
          {available.map(t => <option key={t} value={t}>{t}</option>)}
        </select>
        <input
          value={draft} onChange={e => setDraft(e.target.value)} placeholder="new tag"
          aria-label="New tag"
          onKeyDown={e => { if (e.key === 'Enter' || e.key === ',') { e.preventDefault(); add(draft); setDraft('') } }}
        />
        <button type="button" onClick={() => { add(draft); setDraft('') }} disabled={!norm(draft)} aria-label="Add new tag"><Plus size={13} /></button>
      </div>
    </div>
  )
}
